document.addEventListener("sections:loaded", () => {
  if (typeof EmblaCarousel === "undefined") {
    return;
  }

  document.querySelectorAll("[data-blog-carousel]").forEach((root) => {
    const viewport = root.querySelector(".embla__viewport");
    const section = root.closest(".section-blog");

    if (!viewport || !section) {
      return;
    }

    const slideCount = viewport.querySelectorAll(".embla__slide").length;
    if (slideCount === 0) {
      return;
    }

    const embla = EmblaCarousel(viewport, {
      align: "start",
      containScroll: "trimSnaps",
    });

    const prevButton = section.querySelector(".carousel-prev");
    const nextButton = section.querySelector(".carousel-next");

    const updateButtons = () => {
      prevButton?.classList.toggle("is-disabled", !embla.canScrollPrev());
      nextButton?.classList.toggle("is-disabled", !embla.canScrollNext());
    };

    prevButton?.addEventListener("click", () => embla.scrollPrev());
    nextButton?.addEventListener("click", () => embla.scrollNext());

    embla.on("select", updateButtons);
    embla.on("reInit", updateButtons);
    updateButtons();
  });
});
